import axios from 'axios'
import { Bridge } from '@iskytrip/sdk'

axios.defaults.timeout = 5000
// axios.defaults.baseURL ='http://192.168.1.119:50102/api';

axios.interceptors.request.use(
	(config) => {
		//请求拦截器todo
		return config
	},
	(err) => {
		return Promise.reject(err)
	},
)

axios.interceptors.response.use(
	(response) => {
		//响应拦截器todo
		return response
	},
	(err) => {
		//alert(JSON.stringify(err));
		if (err && err.response) {
			//alert(JSON.stringify(err.response.status));
			switch (err.response.status) {
				case 400:
					console.error('错误请求')
					break
				case 401:
					console.error('未授权，请重新登录')
					break
				case 403:
					console.error('拒绝访问')
					break
				case 404:
					console.error('请求错误,未找到该资源')
					break
				case 405:
					console.error('请求方法未允许')
					break
				case 408:
					console.error('请求超时')
					break
				case 500:
					console.error('服务器端出错')
					break
				case 501:
					console.error('网络未实现')
					break
				case 502:
					console.error('网络错误')
					break
				case 503:
					console.error('服务不可用')
					break
				case 504:
					console.error('网络超时')
					break
				case 505:
					console.error('http版本不支持该请求')
					break
				default:
					console.error(`连接错误${err.response.status}`)
			}
			err.response.toast = 1
		} else {
			console.error('连接到服务器失败')
			err = {
				response: {
					toast: 1,
				},
			}
		}

		Bridge.appGetChannelappToast('网络异常，请稍后重试')
		return Promise.reject(err.response)
	},
)

function get(url, request = {}) {
	return new Promise((resolve, reject) => {
		Bridge.callHandler('AirportHeader')
			.then((header) => {
				axios
					.get(url, { header, request })
					.then((response) => {
						resolve(response && response.data)
					})
					.catch((err) => {
						reject(err)
					})
			})
			.catch((err) => {
				reject(err)
			})
	})
}

function post(url, request = {}) {
	return new Promise((resolve, reject) => {
		Bridge.callHandler('AirportHeader')
			.then((header) => {
				axios
					.post(url, { header, request })
					.then((response) => {
						resolve(response && response.data)
					})
					.catch((err) => {
						reject(err)
					})
			})
			.catch((err) => {
				reject(err)
			})
	})
}

export default {
	get,
	post,
}
